export const EventRadius = 4
export const RangePadding = 8